import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import '../../Assets/Ui/ProfilePanel.css';
import { PhoneFlag, ILFlag, countryFromPhone } from '../../Services/phoneCountry';
import { LangFlag } from '../../Services/patientLang';

export default props => (
    <Panel className="ProfilePanel pa-0">
        <Panel.Body className="pa-0">
            <div className="cover" />
            <div className="profileInfo">
                <div className="profileImage">
                    <img src={props.photoProfil || '/assets/images/profile-picture-placeholder.png'} alt="profilePic" />
                </div>
                <h5 className="blue">
                    {props.FName} {props.LName}
                    {props.phone && (
                        <span title={props.phone} style={{ marginLeft: 6 }}>
                            <PhoneFlag phone={props.phone} />
                        </span>
                    )}
                    {props.isIL && countryFromPhone(props.phone) !== 'IL' && <ILFlag />}
                    {/* Patients only — doctors carry no `lang`, and LangFlag
                        renders nothing for French, so this stays invisible on
                        every profile that has no language to report. */}
                    <LangFlag lang={props.lang} prefix="Écrit en " />
                </h5>
                <h6>{props.favoriteSpecialty}</h6>
            </div>
            <div className="infos">
                {props.children}
                {props.isRequest && !props.isPartner && (
                    <Link to={`/users/detail/${props._id}`}>Voir le profil</Link>
                )}
            </div>
        </Panel.Body>
    </Panel>
);
